import { TireState } from 'app/shared/model/enumerations/tire-state.model';
import { TireStatus } from 'app/shared/model/enumerations/tire-status.model';
import { TireFunction } from 'app/shared/model/enumerations/tire-function.model';
import React from 'react';
import { translate } from 'react-jhipster';
import { Badge } from 'reactstrap';

export const colorTires = (item: TireStatus | TireState | TireFunction) => {
  switch (item) {
    case TireState.NEW:
    case TireStatus.INSTALLED:
    case TireFunction.DIRECTIONAL:      
      return 'success';
    case TireState.NULL:      
    case TireFunction.ROLLING:          
      return 'primary';
    case TireState.RECAP:
    case TireStatus.MAINTENANCE:
      return 'warning';
    case TireStatus.WASTE:
      return 'danger';
    case TireState.USED:
    case TireStatus.STOCK:
    case TireStatus.STEPPE:
    case TireFunction.TRACTION:            
      return 'secondary';
    default:
      return 'secondary';
  }
};

export const renderStatus = (status: TireStatus) => <Badge color={colorTires(status)}>{translate(`fleetSenseApp.TireStatus.${status}`)}</Badge>;

export const renderState = (state: TireState) => <Badge color={colorTires(state)}>{translate(`fleetSenseApp.TireState.${state}`)}</Badge>;

export const renderFunction = (tireFunction: TireFunction) => <Badge color={colorTires(tireFunction)}>{translate(`fleetSenseApp.TireFunction.${tireFunction}`)}</Badge>;
